var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJuno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F9ACAC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8283 16C50.9328 16 51.8283 16.8954 51.8283 18V33.5309L64.3625 21.2101C65.1503 20.4358 66.4166 20.4467 67.1909 21.2344C67.9652 22.0221 67.9543 23.2884 67.1666 24.0627L54.716 36.3012H73C74.1046 36.3012 75 37.1967 75 38.3012C75 39.4058 74.1046 40.3012 73 40.3012H54.716L66.4568 51.842C67.2445 52.6164 67.2554 53.8826 66.4811 54.6704C65.7068 55.4581 64.4405 55.469 63.6527 54.6947L51.8283 43.0716V71.7497H59.0557C60.1603 71.7497 61.0557 72.6451 61.0557 73.7497C61.0557 74.8542 60.1603 75.7497 59.0557 75.7497H51.8283V83C51.8283 84.1046 50.9328 85 49.8283 85C48.7237 85 47.8283 84.1046 47.8283 83V75.7497H40.5779C39.4733 75.7497 38.5779 74.8542 38.5779 73.7497C38.5779 72.6451 39.4733 71.7497 40.5779 71.7497H47.8283V42.9096L36.151 53.8289C35.3442 54.5833 34.0786 54.5409 33.3241 53.7341C32.5697 52.9273 32.6122 51.6617 33.419 50.9072L44.7612 40.3012H27C25.8954 40.3012 25 39.4058 25 38.3012C25 37.1967 25.8954 36.3012 27 36.3012H44.8522L32.6682 24.6203C31.8708 23.8559 31.8441 22.5898 32.6086 21.7925C33.373 20.9952 34.639 20.9685 35.4364 21.7329L47.8283 33.6132V18C47.8283 16.8954 48.7237 16 49.8283 16Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuno);
export default __webpack_public_path__ + "static/media/juno.dd1b6a5a84f2558ce86f11e764e34440.svg";
export { ForwardRef as ReactComponent };